export const FROM_BUY_STANDARD = "getstart/FROM_BUY_STANDARD"
export const FROM_BUY_PRO = "getstart/FROM_BUY_PRO"
export const FROM_TRIAL_STANDARD = "getstart/FROM_TRIAL_STANDARD"
export const FROM_TRIAL_PRO = "getstart/FROM_TRIAL_PRO"
export const FROM_NORMAL = "getstart/FROM_NORMAL"

export const VERSION_STANDARD = "Standard Version"
export const VERSION_PRO = "Pro Version"
export const VERSION_CUSTOMISED = "Customised Version"